export default function Male({color="#4d5c7d"}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.996" height="24" viewBox="0 0 23.996 24">
      <path id="Path_34250" data-name="Path 34250" d="M22.386,0h-6.11a1.662,1.662,0,1,0,0,3.324h2.1L13.716,7.981a8.765,8.765,0,1,0,2.349,2.351l4.659-4.659v2.1a1.662,1.662,0,0,0,3.324,0V1.662A1.662,1.662,0,0,0,22.386,0ZM12.652,19.084a5.437,5.437,0,1,1,0-7.689A5.4,5.4,0,0,1,12.652,19.084Z" transform="translate(-0.052)" fill={color} />
    </svg>
  );
}
